import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LayoutService } from './service/app.layout.service';
import { LocalStorageService } from '../core/service/local-storage.service';
import { LocalStorageEnum } from '../shared/enum.ts/local-storage.enum';
import { AuthService } from '../core/service/auth.service';
import { AppMenuitemComponent } from './app.menuitem.component';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitemComponent],
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  readonly layoutService = inject(LayoutService);
  private readonly localStorage = inject(LocalStorageService);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  model: any[] = [];
  role: string = 'STORE_ADMIN';

  ngOnInit(): void {
    const user = this.localStorage.getItem(LocalStorageEnum.USER);
    this.role = user.roleName;
    let items = [];
    if (this.role === 'SUPER_ADMIN') {
      items = superAdmin;
    } else if (this.role === 'STORE_ADMIN') {
      items = storeAdmin;
    } else if (this.role === 'MANAGER') {
      items = manager;
    }
    this.model = [
      {
        label: 'Home',
        items: [
          ...items,
          {
            label: 'Sign Out',
            icon: 'pi pi-fw pi-user',
            command: () => this.signOut(),
          },
        ],
      },
    ];
  }

  handleClick(item: any): void {
    if (item.click) {
      item.click();
    }
  }

  private signOut(): void {
    this.authService
      .logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.authService.clearSession(),
        error: () => this.authService.clearSession(),
      });
  }
}

const manager = [
  { label: 'Orders', icon: 'pi pi-fw pi-shopping-bag', routerLink: ['/order'] },
  { label: 'Notification', icon: 'pi pi-fw pi-bookmark-fill', routerLink: ['/notifications'] },
];
const storeAdmin = [
  { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
  { label: 'User', icon: 'pi pi-fw pi-user', routerLink: ['/user'] },
  { label: 'Customers', icon: 'pi pi-fw pi-users', routerLink: ['/customer'] },
  { label: 'Menu Item', icon: 'pi pi-fw pi-table', routerLink: ['/menu-item'] },
  { label: 'Orders', icon: 'pi pi-fw pi-shopping-bag', routerLink: ['/order'] },
  { label: 'Inventory Item', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/inventory-item'] },
  { label: 'Store Inventory', icon: 'pi pi-fw pi-book', routerLink: ['/store-inventory'] },
  { label: 'Notification', icon: 'pi pi-fw pi-bookmark-fill', routerLink: ['/notifications'] },
];
const superAdmin = [
  { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
  {
    label: 'Users',
    icon: 'pi pi-fw pi-user',
    items: [
      { label: 'All users', icon: 'pi pi-fw pi-users', routerLink: ['/user'] },
      { label: 'Soft-deleted users', icon: 'pi pi-fw pi-trash', routerLink: ['/user/soft-deleted-users'] },
    ],
  },
  { label: 'Customers', icon: 'pi pi-fw pi-users', routerLink: ['/customer'] },
  { label: 'Category', icon: 'pi pi-fw pi-th-large', routerLink: ['/category'] },
  { label: 'Dish', icon: 'pi pi-fw pi-list', routerLink: ['/dish'] },
  { label: 'Menu Item', icon: 'pi pi-fw pi-table', routerLink: ['/menu-item'] },
  { label: 'Side Lines', icon: 'pi pi-fw pi-list', routerLink: ['/side-line'] },
  { label: 'Orders', icon: 'pi pi-fw pi-shopping-bag', routerLink: ['/order'] },
  { label: 'Store', icon: 'pi pi-fw pi-building', routerLink: ['/store'] },
  { label: 'Inventory Item', icon: 'pi pi-fw pi-shopping-cart', routerLink: ['/inventory-item'] },
  { label: 'Store Inventory', icon: 'pi pi-fw pi-book', routerLink: ['/store-inventory'] },
  { label: 'Loyalty Coupons', icon: 'pi pi-fw pi-ticket', routerLink: ['/loyalty-coupon'] },
  { label: 'Store Rating', icon: 'pi pi-fw pi-star', routerLink: ['/store-rating'] },
  { label: 'Notification', icon: 'pi pi-fw pi-bookmark-fill', routerLink: ['/notifications'] },
  { label: 'Loyalty Program', icon: 'pi pi-fw pi-bookmark-fill', routerLink: ['/loyalty-program'] },
];
